module.exports = __webpack_public_path__ + "img/my-prize-img.42734113.png";